/* eslint-disable @typescript-eslint/camelcase */
import React, {
  useRef,
  useEffect,
  useMemo,
  useCallback,
  useReducer,
  useState
} from "react"
import style from "./index.module.scss"
import { Action } from "types/interface"
import { createAction, SET_PAYTYPE } from "store/ActionTypes"
import {
  $submitOrders,
  $orderStatus,
  $paypalSubscription,
  $alipaySubscription,
  $alipaySubscriptionStatus,
} from "service/recharge"
import { PayTypeEnum } from "types/enum"
import { OK, RouterPaths } from "utils/constant"
import { $userInfo } from "service/sign"
import { useDispatch } from "redux-react-hook"
import { qsFromResultUrl } from "utils/dom"
import { RechargeStatus, RechargeProps } from "."
import PayList from "./Paylist"
// import GoodsInfo from "./GoodsInfo"
import PayQr from "./PayQr"
import ContactUs from "./ContactUs"
import Message from "components/model/ModelFn"
import { filter } from "utils/filter"
import useUpdateEffect from "hooks/useUpdateEffect"
import { payTypeToCurrencySymbol,isMobile } from 'utils/utils'
import { UseCoupon } from "../RechargeList"
import wxqrImg from "assets/img/png/wx_qr.jpg"

interface RechargeInfo {
  curPay: PayTypeEnum | null
  status: RechargeStatus
  ordersInfo: any
  failText: string | null
}

function rechargeReducer(state: RechargeInfo, action: Action): RechargeInfo {
  switch (action.type) {
  case "init":
    return Object.assign({}, state, {
      curPay: null,
      status: RechargeStatus.noselect,
    })
  case "selectPay":
    return Object.assign({}, state, {
      curPay: action.value,
      status:
          action.value === PayTypeEnum.paypal
            ? RechargeStatus.selectPayPal
            : RechargeStatus.loading,
    })
  case "setOrdersInfo":
    return Object.assign({}, state, {
      ordersInfo: action.value,
      status: RechargeStatus.paying,
    })
  case "countDownEnd":
    return Object.assign({}, state, {
      status: RechargeStatus.fail,
      failText: null
    })
  case "submitOrderFail":
    return Object.assign({}, state, {
      status: RechargeStatus.fail,
      failText: action.value
    })
  default:
    return Object.assign({}, state, {
      [action.type]: action.value,
    })
  }
}

const RechargeBox: React.FC<RechargeProps> = ({ payDatas, curGoods, couponPrice, useCode, Complete, hint, setuseCode, setComplete, sethint, ismodify, setismodify,setval,val,setcheckoutCoupon,checkoutCoupon }) => {
  // const [ismodify, setismodify] = useState(false)
  const [status, setstatus] = useState(0)
  const dispatch = useDispatch()
  // 当重新选择支付方式或商品后，还没有做完的步骤取消
  const renderId = useRef(0)
  // 获取paypal支付回跳后的结果
  const search = useMemo(qsFromResultUrl, [])
  // const history = useHistory()
  const [rechargeState, rechargeDispatch] = useReducer(rechargeReducer, {
    curPay: null,
    status: RechargeStatus.noselect,
    ordersInfo: null,
    failText: null
  })
  // 是否使用支付宝订阅, 默认选择，可以取消
  const isUseAlipaySub = useRef(true)
  const [btn,setbtn] = useState(true)

  const checkOrder = useCallback(
    async (order_no: string, ordersInfo?: any, payer_id?: string, re = false) => {
      try {
        // console.log('checkorder触发一次')

        const rid = re === true ? renderId.current : renderId.current + 1
        let body: any
        if (isUseAlipaySub.current && ordersInfo && ordersInfo.transaction_id) {
          body = await $alipaySubscriptionStatus(ordersInfo.subscription_id, ordersInfo.transaction_id)
        } else {
          body = await $orderStatus(order_no, payer_id)
        }
        if (rid !== renderId.current) return
        if (body.code === 0 && (body.data.paid || body.data.transaction_status === "success")) {
          rechargeDispatch(createAction("status", RechargeStatus.success))
          // 更新用户信息
          $userInfo()
          // 特殊商品充值成功后刷新
          if (curGoods.special_offer) {
            Message.confirm({
              text: '充值成功,此套餐仅限购买一次',
              noCancel: true,
              onClose: () => window.location.href = RouterPaths.home
            })
          }
        } else {
          // 支付成功状态只查一次
          if (search.status === "success") {
            return
          }
          const rid = renderId.current
          setTimeout(() => {
            if (rid === renderId.current) {
              checkOrder(order_no, ordersInfo, payer_id, true)
            }
          }, 6000)
        }
      } catch (e) {
        console.log(e)
      }
    },
    [curGoods.special_offer, search.status],
  )

  const submitOrders = useCallback(
    async (id: number, pay: string, re = false) => {
      if(pay === 'wx_pub_qr') return
      try {
        const rid = re === true ? renderId.current : renderId.current + 1
        let body: any
        // console.log(   couponPrice.discount,ismodify,!ismodify&&!couponPrice.discount)
        // if (!ismodify && !couponPrice.discount) { return }
        if (isUseAlipaySub.current && pay === PayTypeEnum.alipay_qr && curGoods.alipay_renewable && ismodify) {
          body = await $alipaySubscription(id, "qr")
        } else {
          if(checkoutCoupon){
            body = await $submitOrders(id, pay, couponPrice.coupon_code)
          }else{
            body = await $submitOrders(id, pay)
          }
          
        }
        // console.log('rid', rid, renderId.current)

        if (rid !== renderId.current) return
        if (body.code === 0) {
          if (pay === PayTypeEnum.paypal) {
            window.open(body.data.paypal.approval_url, "_self")
            return
          }
          if (pay === PayTypeEnum.union ) {
            window.location.href = body.data.union.qr_url
            return
          }
          rechargeDispatch(createAction("setOrdersInfo", body.data))
          // 查询订单
          checkOrder(body.data.order_no, body.data)
        } else {
          if (body.code !== 20001) {
            rechargeDispatch(createAction(
              "submitOrderFail",
              filter(body.code, body.error)
            ))
          } else {
            rechargeDispatch({ type: "init" })
          }
        }
      } catch (e) {
        console.log(e)
        rechargeDispatch(createAction(
          "submitOrderFail",
          e.message
        ))
      }
    },
    [checkOrder, curGoods.alipay_renewable, couponPrice, ismodify,checkoutCoupon],
  )

  const selectPayType = useCallback(
    (pay: PayTypeEnum) => {
      setbtn(true)
      // 如果当前选择的商品不为空
      // console.log('pay',pay)
      // console.log();
      
      // if(!ismodify && !couponPrice)
      // console.log(ismodify,curGoods.id, curGoods.service_days,couponPrice)
      // if(!ismodify&&!couponPrice.discount){return}
      if (curGoods.service_days) {
        dispatch(createAction(SET_PAYTYPE, pay))
        // 改变state
        rechargeDispatch(createAction("selectPay", pay))
        // 如果是PayPal则不用下单
        if (pay === PayTypeEnum.paypal) {
          return
        }
        //动态关闭VIP折扣码
        
        if(!JSON.parse(localStorage.links).url.default_discount_code.split('_')[0]){ 
          submitOrders(curGoods.id, pay)
        }else{
          if(!checkoutCoupon){
            submitOrders(curGoods.id, pay,status>0?true:false)
            setstatus(0)
          }else{
                
            if(!ismodify&&!couponPrice.discount ){ 
              setstatus(1)
              // submitOrders(curGoods.id, pay)
              if(!localStorage.UserInfo){
                Message.confirm({
                  text: "请先登录穿梭账号",
                  onConfirm: () => { isMobile() ? window.location.replace(RouterPaths["signin-phone"]) : window.location.replace(RouterPaths["signin-qr"]) },
                  noCancel: true
                })
              }
            }else{  
              submitOrders(curGoods.id, pay,status>0?true:false)
              setstatus(0)
            }
          }
             
        }
         
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [curGoods.id, curGoods.service_days, dispatch, submitOrders,ismodify,couponPrice,status],
  )

  const paypalSubscription = useCallback(
    async (re = false) => {
      rechargeDispatch(createAction("status", RechargeStatus.loading))
      try {
        const rid = re === true ? renderId.current : renderId.current + 1
        const body = await $paypalSubscription(curGoods.id)
        if (rid !== renderId.current) return
        if (body.status === OK) {
          window.open(body.data.approval_url, "_self")
        } else {
          if (body.code !== 20001) {
            rechargeDispatch(createAction(
              "submitOrderFail",
              filter(body.code, body.error)
            ))
          }
        }
      } catch (e) {
        rechargeDispatch(createAction(
          "submitOrderFail",
          e.message
        ))
      }
    },
    [curGoods.id],
  )

  const paypalCheckOut = useCallback(async () => {
    rechargeDispatch(createAction("status", RechargeStatus.loading))
    submitOrders(curGoods.id, PayTypeEnum.paypal)
  }, [curGoods.id, submitOrders])

  const countDownEnd = useCallback(() => {
    rechargeDispatch({ type: 'countDownEnd' })
  }, [])

  const againRecharge = useCallback(() => {
    if (rechargeState.curPay) {
      selectPayType(rechargeState.curPay)
    } else if (search.status) {
      window.location.href = RouterPaths.home
    }
  }, [rechargeState.curPay, selectPayType, search])

  const againCheck = () => {
    setbtn(false)
    checkOrder(rechargeState.ordersInfo.order_no,rechargeState.ordersInfo)
    rechargeDispatch(createAction("status", RechargeStatus.querying))
  }
  // 勾选或取消支付宝订阅选项
  const changeSelectAlipaySub = useCallback((use: boolean) => {
    isUseAlipaySub.current = use
    againRecharge()
  }, [againRecharge])

  useEffect(() => {
    return () => {
      renderId.current += 1
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rechargeState.status, rechargeState.curPay, curGoods.service_days])

  useUpdateEffect(() => {
    // rechargeDispatch({ type: "init" })
    // 已经选择了支付方式的情况下改变商品则重新下单
    againRecharge()
  }, [curGoods.service_days])

  // 根据paypal支付回调的结果做处理
  useEffect(() => {
    if (search.status) {
      if (search.status === "success") {
        rechargeDispatch(createAction("status", RechargeStatus.success))
        if(!search.out_trade_no) return
        checkOrder(search.out_trade_no, null, search.PayerID)
      } else {
        rechargeDispatch(createAction("status", RechargeStatus.fail))
      }
    }
    // console.log('couponPrice',couponPrice)
    // console.log(curGoods,'curGoods')

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [couponPrice, curGoods])

  return (
    <div className={style["recharge-box"]}>
      <div className={style.left}>
        <div className={style.title}>请选择支付方式</div>
        <PayList
          payDatas={payDatas}
          onSelectPay={selectPayType}
          curPay={rechargeState.curPay}
        />
        <ContactUs />
      </div>
      <div className={style.right}>
        <PayTitle curPay={rechargeState.curPay} />
        {/* <GoodsInfo goodsData={curGoods} curPay={rechargeState.curPay} coupon={couponPrice} /> */}
        {
          rechargeState.curPay === 'wx_pub_qr' ? <div className={style.couponInfo}><img className={style.wxqrImg} src={wxqrImg} alt="" /> </div> : (
            <div className={style.couponInfo}>
              <CouponInfo  setcheckoutCoupon={setcheckoutCoupon} 
                checkoutCoupon={checkoutCoupon} 
                val={val}
                setval={setval} ismodify={ismodify} setismodify={setismodify} goodsData={curGoods} curPay={rechargeState.curPay} couponPrice={couponPrice} useCode={useCode} Complete={Complete} hint={hint} setuseCode={setuseCode} setComplete={setComplete} sethint={sethint} />
              <PayQr
                ismodify={ismodify}
                couponPrice={couponPrice}
                ordersInfo={rechargeState.ordersInfo}
                status={rechargeState.status}
                curPay={rechargeState.curPay}
                paypalCheckOut={paypalCheckOut}
                paypalSubscription={paypalSubscription}
                countDownEnd={countDownEnd}
                againRecharge={againRecharge}
                btn={btn}
                againCheck={againCheck}
                isSpecial={curGoods.special_offer}
                failText={rechargeState.failText}
                countDownSeconds={180}
                canAlipaySub={rechargeState.curPay === PayTypeEnum.alipay_qr && curGoods.alipay_renewable}
                isUseAlipaySub={isUseAlipaySub.current}
                changeSelectAlipaySub={changeSelectAlipaySub}
              />
            </div>
          )
        }

      </div>
    </div>
  )
}

interface PayTitleProps {
  curPay: PayTypeEnum | null
}

const PayTitle: React.FC<PayTitleProps> = ({ curPay }) => {
  const text = useMemo(() => {
    switch (curPay) {
    case null:
      return "请选择充值套餐"
    case PayTypeEnum.paypal:
      return "请选择下方支付方案跳转支付"
    case PayTypeEnum.union:
      return "请跳转链接完成支付"
    case PayTypeEnum.wx_pub_qr:
      return "跳转微信小程序购买"
    case PayTypeEnum.wx_native_qr:
      return "请使用微信扫描下方二维码付款"
    case PayTypeEnum.alipay:
    case PayTypeEnum.alipay_qr:
    case PayTypeEnum.alipay_wap_intl:
    case PayTypeEnum.alipay_qr_intl:
      return "请使用支付宝扫描下方二维码付款"
    default:
      return "请选择使用手机扫描下方二维码付款"
    }
  }, [curPay])

  return (
    <div className={style.title}>
      {text}
    </div>
  )
}

interface CouponInfoProp {
  goodsData?: any;
  curPay?: any;
  couponPrice?: any
  useCode?: any;
  Complete?: any;
  hint?: any;
  setuseCode?: any;
  setComplete?: any;
  sethint?: any;
  setismodify?: any;
  ismodify?: boolean;
  val?: any;
  setval?: any;
  checkoutCoupon?: any;
  setcheckoutCoupon?: any;
}

const CouponInfo: React.FC<CouponInfoProp> = ({ goodsData, curPay, couponPrice, useCode, Complete, hint, setuseCode, setComplete, sethint, ismodify, setismodify,setval,val,setcheckoutCoupon,checkoutCoupon }) => {
  // const [useCode, setuseCode] = useState(false)
  // const [Complete, setComplete] = useState(false)
  // const [hint, sethint] = useState(null)
  // useEffect(() => {
  //   console.log('goodsData.present_price',goodsData.present_price)
  //   console.log( goodsData.present_price,((localStorage.links && JSON.parse(localStorage.links).url.default_discount_code ? JSON.parse(localStorage.links).url.default_discount_code.split('_')[1] : 20)-0) )

  // }, [goodsData]) 
  const getCouponPrice = (pay,type) => {
    switch (pay) {
    case PayTypeEnum.paypal:
      return couponPrice[`${type}_price_usd`]
    case PayTypeEnum.alipay_qr_intl:
      return couponPrice[`${type}_price_hkd`]
    default:
      return couponPrice[`${type}_price`]

    }
  }
  
  return <div className={style.couponPrice}>
    <div className={style.originalPrice}>
      <div>原价</div>
      <div>{payTypeToCurrencySymbol(curPay)}{goodsData.present_price}</div>
    </div>
    <div className={style.discountPrice}>
      {/* <div>折扣 {localStorage.UserInfo ? (couponPrice.discount ? couponPrice.discount * 100 : 0) : localStorage.links && JSON.parse(localStorage.links).url.default_discount_code && store.getState().recharge.is_default_coupon ? JSON.parse(localStorage.links).url.default_discount_code.split('_')[1] : 20}%</div> */}
      <div>折扣 {couponPrice.discount ? couponPrice.discount * 100 : 0}%</div>
      <div>{couponPrice.discount_price ? '-' + payTypeToCurrencySymbol(curPay) + (getCouponPrice(curPay,'discount')/100).toFixed(2) : 0}</div>
      {/* <div>{localStorage.UserInfo
        ? (couponPrice.discount_price ? '-' + payTypeToCurrencySymbol(curPay) + (Math.floor(goodsData.present_price * 100 * (couponPrice.discount * 100)) / 10000).toFixed(2) : 0)
        : '-' + payTypeToCurrencySymbol(curPay) + (goodsData.present_price * 1000) * (localStorage.links && JSON.parse(localStorage.links).url.default_discount_code  && store.getState().recharge.is_default_coupon ? JSON.parse(localStorage.links).url.default_discount_code.split('_')[1] : 20) / 100000}</div> */}
    </div>
    <div className={style.line} />
    <div className={style.actualPrice}>
      <div>实际价格</div>
      <div>{couponPrice.discount_price ? payTypeToCurrencySymbol(curPay) + ((getCouponPrice(curPay,'original') - getCouponPrice(curPay,'discount'))/100).toFixed(2) : payTypeToCurrencySymbol(curPay) + (goodsData.present_price || 0)}</div>
      {/* <div>{localStorage.UserInfo
        ? (couponPrice.discount_price ? payTypeToCurrencySymbol(curPay) + ((goodsData.present_price * 100 * (100 - couponPrice.discount * 100)) / 10000).toFixed(2) : payTypeToCurrencySymbol(curPay) + (goodsData.present_price || 0))
        : payTypeToCurrencySymbol(curPay) + (goodsData.present_price * 1000) * (localStorage.links && JSON.parse(localStorage.links).url.default_discount_code && store.getState().recharge.is_default_coupon ? (100 - JSON.parse(localStorage.links).url.default_discount_code.split('_')[1]) : 20) / 100000}</div> */}
    </div>
    <div className={style.UseCoupon}>
      <UseCoupon setcheckoutCoupon={setcheckoutCoupon} checkoutCoupon={checkoutCoupon} val={val} setval={setval} setismodify={setismodify} ismodify={ismodify} goodsId={goodsData.id} setuseCode={setuseCode} useCode={useCode} setComplete={setComplete} Complete={Complete} sethint={sethint} hint={hint} />
    </div>

  </div>
}



export default React.memo(RechargeBox)

